























































































import { Vue, Component } from 'vue-property-decorator'
import { User } from '@/interfaces/UserInterfaces'
import UserService from '@/services/UserService'

@Component({
  name: 'ProfileForm'
})
export default class ProfileForm extends Vue {
  user!: User

  userDataForm: any = {
    candidateNumber: null as number | null,
    gender: null as any
  }

  isUserDataChanged: boolean = false
  genderOptions: Array<any> = []

  async created() {
      this.user = await UserService.getUser()
        console.log('USER', this.user)


      this.genderOptions = [
        {
          label: this.$t('male'),
          value: 1
        },
        {
          label: this.$t('female'),
          value: 2
        }
      ]

      this.mapProfileForm()
      console.log('FORM', this.userDataForm)
  }

 get userUploaded(): boolean {
    return !!this.user
}

  async submit (): Promise<void> {
    this.errors.clear()

    if (
      !this.userDataForm.gender ||
      (!this.userDataForm.gender.value &&
        this.userDataForm.gender.value !== 0)
    ) {
      this.errors.add({
        field: 'gender',
        msg: this.$tc('gender_is_required')
      })
    }

    await this.$validator.validateAll()

    if (this.errors.count() !== 0) {
      this.$el.querySelector('.error')!.scrollIntoView(false)
      return
    }

    try {
      const response = await UserService.update(this.user.id, {
        candidateNumber: this.userDataForm.candidateNumber,
        gender: this.userDataForm.gender
          ? this.userDataForm.gender.value
          : null
      })

      await this.$auth.setToken(response)

      this.$validator.pause()
      this.errors.clear()

      this.user = await UserService.getUser(true)

      this.mapProfileForm()

      this.isUserDataChanged = true

      setTimeout(() => {
        this.isUserDataChanged = false
      }, 3000)
    } catch (error) {
      if ('response' in error && error.response.status === 400) {
        this.handleProfileFormErrors(error.response.data)
      } else {
        throw error
      }
    }
  }

  handleProfileFormErrors (response: any): void {
    Object.keys(response.errors).forEach((field: string) => {
      if (response.errors[field] && response.errors[field][0]) {
        this.errors.add({
          field,
          msg: response.errors[field][0]
        })
      }
    })
  }

  resetProfileForm (): void {
    this.mapProfileForm()

    this.$validator.pause()
    this.errors.clear()
  }

mapProfileForm (): void {
    console.log('Mapping user', this.user)

  this.userDataForm = {
    candidateNumber: this.user.candidateNumber,
    gender:
      this.genderOptions.find(
        g => g.value === this.user.gender
      ) || null
  }
}

  genderChanged (selectedOption: any): void {
    if (!selectedOption) {
      this.errors.add({
        field: 'gender',
        msg: this.$tc('gender_is_required')
      })
      return
    }

    if (this.errors.has('gender')) {
      this.errors.remove('gender')
    }
  }
}
